import React from "react";
import { connect } from "react-redux";
import { normalizeMoney, required } from "../utility";
import { reduxForm, Field, reset } from "redux-form";
import * as agent from "../agent";
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SubmitButton from './SubmitButton';
import InfoInput from "./InfoInput";
import Preloader from './Preloader';
import Button from '@material-ui/core/Button';
import { MaterialTextField } from "./MaterialInput";
import { MESSAGE_SENDED } from "../constants/actionTypes";

const cashIncomeForm = ({ office, device, balance, onCashIncome, handleSubmit }) => (
    <form className="common-form" onSubmit={handleSubmit(data => onCashIncome(office, device, data))}>
        <InfoInput label="Остаток"
                   endAdornment="₽"
                   placeholder={normalizeMoney(balance)} />
        <Field name="sum"
               label="Сумма к внесению"
               normalize={normalizeMoney}
               format={normalizeMoney}
               endAdornment="₽"
               validate={required}
               component={MaterialTextField} />
        <SubmitButton label="Внести наличные" />
    </form>
);

const CashIncomeForm = reduxForm({ form: "cash-income-form", onSubmitSuccess: (result, dispatch) => dispatch(reset("cash-income-form")) })(cashIncomeForm);


class CashMachines extends React.Component {

    state = {
        statusLoaded: false,
        loading: false,
        moscow: null,
        newcherkassky: null
    };

    componentWillMount = () => {

        this.setState({ statusLoaded: false });
        this.getStatus();

    }

    getStatus = () => {
        agent.Websocket.getStatus()
            .then(res => this.setState({ statusLoaded: true, moscow: res.moscow, newcherkassky: res.newcherkassky }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    closeShift = (office, device) => {
        this.setState({ loading: true });
        agent.Websocket.closeShift(office, device)
            .then(res => {
                this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Смена закрыта", type: "success" } });
                this.setState({ loading: false })
            })
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    onCashIncome = (office, device, data) => {
        agent.Websocket.cashIncome(office, device, {sum: Number(data.sum.replace(/\s/g,``))})
            .then(res => {
                this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Сумма успешно внесена", type: "success" } })
                this.getStatus();
            })
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    render() {
        const { statusLoaded, loading, moscow, newcherkassky } = this.state;
        const nwc = newcherkassky || {};
        const msc = moscow || {};
        return (
            <Fade in={true}>
                {statusLoaded ? 
                    <Grid container justify="center" spacing={16} style={{ marginTop: 20, marginBottom: 20 }}>
                        <Grid item >
                            <Paper className="common-paper" >
                                <Typography variant="h5" align="center" gutterBottom>НВЧ:</Typography>
                                {newcherkassky ? 
                                    <Grid container justify="center" spacing={16}>
                                        <Grid item class="common-column common-form" style={{ paddingLeft: 8, paddingRight: 8 }}>
                                            <Typography align="center" gutterBottom>Касса "Лизинг"</Typography>
                                            <InfoInput label="Статус"
                                                       placeholder={nwc.leasing ? "Подключена" : "Не подключена"} />
                                            {nwc.leasing && 
                                                <CashIncomeForm office="newcherkassky"
                                                                device="leasing"
                                                                balance={nwc.leasingBalance} 
                                                                onCashIncome={this.onCashIncome}/>
                                            }
                                            <Typography align="center" gutterBottom>Операции со сменой:</Typography>
                                            {nwc.leasing && <Button type="submit"
                                                    onClick={() => this.closeShift("newcherkassky", "leasing")}
                                                    disabled={loading}
                                                    fullWidth
                                                    color="primary"
                                                    variant="contained">Закрыть</Button>
                                            }
                                        </Grid>
                                        <Grid item class="common-column common-form" style={{ paddingLeft: 8, paddingRight: 8 }}>
                                            <Typography align="center" gutterBottom>Касса "Автоломбард"</Typography>
                                            <InfoInput label="Статус"
                                                       placeholder={nwc.pawnshop ? "Подключена" : "Не подключена"} />
                                            {nwc.pawnshop && 
                                                <CashIncomeForm office="newcherkassky"
                                                                device="pawnshop"
                                                                balance={nwc.pawnshopBalance}  
                                                                onCashIncome={this.onCashIncome}/>
                                            }
                                            <Typography align="center" gutterBottom>Операции со сменой:</Typography>
                                            {nwc.pawnshop && 
                                            <Button type="submit"
                                                    onClick={() => this.closeShift("newcherkassky", "pawnshop")}
                                                    disabled={loading}
                                                    fullWidth
                                                    color="primary"
                                                    variant="contained">Закрыть</Button>
                                            }
                                        </Grid>
                                    </Grid> : <Typography >Компьютер, отвечающий за связь с кассовыми аппаратом не подключен. Запустите ярлык restart на рабочем столе</Typography>
                                }
                            </Paper>
                        </Grid>
                        <Grid item >
                            <Paper className="common-paper" >
                                <Typography variant="h5" align="center" gutterBottom>МСК:</Typography>
                                {moscow ? 
                                    <Grid container spacing={16}>
                                        <Grid item class="common-column" style={{ paddingLeft: 8, paddingRight: 8 }}>
                                            <Typography align="center" gutterBottom>Касса "Лизинг"</Typography>
                                            <InfoInput label="Статус"
                                                       placeholder={msc.leasing ? "Подключена" : "Не подключена"} />
                                            {msc.leasing && 
                                            <CashIncomeForm office="moscow"
                                                            device="leasing"
                                                            balance={msc.leasingBalance}
                                                            onCashIncome={this.onCashIncome} />}
                                            <Typography align="center" gutterBottom>Операции со сменой:</Typography>
                                            {msc.leasing && <Button type="submit"
                                                    onClick={() => this.closeShift("moscow", "leasing")}
                                                    disabled={loading}
                                                    fullWidth
                                                    color="primary"
                                                    variant="contained">Закрыть</Button>}
                                        </Grid>
                                        <Grid item class="common-column" style={{ paddingLeft: 8, paddingRight: 8 }}>
                                            <Typography align="center" gutterBottom>Касса "Автоломбард"</Typography>
                                            <InfoInput label="Статус"
                                                       placeholder={msc.pawnshop ? "Подключена" : "Не подключена"} />
                                            {msc.pawnshop && <CashIncomeForm office="moscow"
                                                            device="pawnshop"
                                                            balance={msc.pawnshopBalance}
                                                            onCashIncome={this.onCashIncome} />}
                                            <Typography align="center" gutterBottom>Операции со сменой:</Typography>
                                            {msc.pawnshop && <Button type="submit"
                                                    onClick={() => this.closeShift("moscow", "pawnshop")}
                                                    disabled={loading}
                                                    fullWidth
                                                    color="primary"
                                                    variant="contained">Закрыть</Button>}
                                        </Grid>
                                        
                                    </Grid> : <Typography >Компьютер, отвечающий за связь с кассовыми аппаратом не подключен. Запустите ярлык restart на рабочем столе</Typography>
                                }
                            </Paper>
                        </Grid>
                    </Grid> : <Preloader />
                }
            </Fade>
        )
    }
}

export default connect(null,null)(CashMachines);



// WEBPACK FOOTER //
// ./src/components/CashMachines.js